import React, { SyntheticEvent, useCallback } from 'react'
import SnackbarMaterial, {
  SnackbarProps as SnackbarMaterialProps,
  SnackbarCloseReason
} from '@mui/material/Snackbar'

// import styles from './Tooltip.module.scss'

const POSITION_BOTTOMCENTER: SnackbarProps['anchorOrigin'] = {
  vertical: 'bottom',
  horizontal: 'center'
}

type SnackbarProps = SnackbarMaterialProps & {
  disableCloseClickaway?: boolean
}

const Snackbar: React.FC<SnackbarProps> = props => {
  const { disableCloseClickaway, message, onClose, open, ...restProps } = props

  const handleClose = useCallback(
    (event: SyntheticEvent | Event, reason: SnackbarCloseReason) => {
      if (disableCloseClickaway && reason === 'clickaway') {
        return
      }

      onClose?.(event, reason)
    },
    [disableCloseClickaway, onClose]
  )

  return (
    <SnackbarMaterial
      {...restProps}
      anchorOrigin={POSITION_BOTTOMCENTER}
      open={open}
      autoHideDuration={5000}
      onClose={handleClose}
      message={message}
      key={POSITION_BOTTOMCENTER.vertical + POSITION_BOTTOMCENTER.horizontal}
    />
  )
}

export default Snackbar
